import { User } from './user';

export class AccountManager {
	public id: number;
	public userId: string;
	public headshotAttachmentId: string;
	public title: string;
	public isDefault: boolean;
	public bookingLink: string;

	public user: User;

	constructor(accountManager?: AccountManager) {
		Object.assign(this, accountManager);

		this.user = this.user ? new User(this.user) : this.user;
	}

	get userFullName() {
		return this.user?.fullName;
	}
}
